import AboutContent from "../components/AboutContent"




const About = () => {
  return <AboutContent></AboutContent>
  
}

export default About
